module.exports = __webpack_public_path__ + "img/pro_01.d5fe5938.jpg";